import React from 'react';
import StudentDecisionReport from './StudentDecisionReport';
export default function MonthlyReport(){return <StudentDecisionReport mode="monthly"/>;}
